import { render, staticRenderFns } from "./releaseEnquiry.vue?vue&type=template&id=618b8d33&scoped=true"
import script from "./releaseEnquiry.vue?vue&type=script&lang=js"
export * from "./releaseEnquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b8d33",
  null
  
)

export default component.exports